import { ROUTES } from '@/shared/constants/routes';
import { Loader } from '@/view/shared/Loader';
import { useWorkspaceDataAccessViewModel } from '@/viewmodel/features/dataConsole';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export function ProtectedRouteWorkspaceData({ children }: Readonly<{ children: ReactNode }>) {
  const { canOpen, isLoading } = useWorkspaceDataAccessViewModel();

  if (isLoading) return <Loader />;
  if (!canOpen) return <Navigate to={ROUTES.PROJECTS} replace />;

  return <>{children}</>;
}
